import { AfterViewChecked, ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '@components/button/component/button.component';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';

/**
 * Данные для диалога ConfirmDialogComponent
 */
interface IConfirmDialogData {
    title: string;
    message: string;
    yesText?: string;
    noText?: string;
}

/**
 * Диалог типа "Подтверждение действия"
 */
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements AfterViewChecked {
    readonly dictionary = inject(LANG_DICTIONARY_TOKEN);
    readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent, boolean>);
    readonly data: IConfirmDialogData = inject(MAT_DIALOG_DATA);

    /** Ссылка на кнопку нет */
    @ViewChild('buttonNo') private _buttonNoRef: ButtonComponent;

    /** Флаг установки фокуса на кнопку */
    private initFocus: boolean = false;

    public ngAfterViewChecked(): void {
        if (!this.initFocus) {
            this._buttonNoRef?.focus();
        }
        this.initFocus = true;
    }
}
